export const effectiveStudioOwner = (
  storedOwner: unknown,
  createdByOrganization: unknown
): string => {
  const stored = String(storedOwner ?? "").trim();
  if (stored) {
    return stored;
  }
  return String(createdByOrganization ?? "").trim();
};

export const creatorStudioName = (product: any): string => {
  const fromProduct = String(product?.createdByOrganization ?? "").trim();
  if (fromProduct) {
    return fromProduct;
  }
  return String(product?.organizations?.[0]?.name ?? "").trim();
};

export const filledOwnersFromProduct = (product: any) => {
  const creator = creatorStudioName(product);
  return {
    productOwner: effectiveStudioOwner(product?.productOwner, creator),
    designOwner: effectiveStudioOwner(product?.designOwner, creator),
  };
};

export const currentStudioName = (authUser: any): string => {
  const fromJwt = String(authUser?.users?.organizationResponse?.name ?? "").trim();
  if (fromJwt) {
    return fromJwt;
  }
  try {
    const profile = JSON.parse(localStorage.getItem("GetUserRes") || "null");
    return String(profile?.organizationDetails?.[0]?.name ?? "").trim();
  } catch {
    return "";
  }
};

export const isCurrentStudioOwner = (
  storedOwner: unknown,
  createdByOrganization: unknown,
  studioName: unknown
): boolean => {
  const owner = effectiveStudioOwner(storedOwner, createdByOrganization);
  const studio = String(studioName ?? "").trim();
  return Boolean(owner && studio && owner.toLowerCase() === studio.toLowerCase());
};

export const canTransferProduct = (product: any, authUser: any): boolean => {
  if (!product || product.archived === true || product.transfer === true) {
    return false;
  }
  const status = String(product.status || "").trim().toUpperCase();
  if (status === "DRAFTED") {
    return false;
  }
  return isCurrentStudioOwner(
    product.productOwner,
    creatorStudioName(product),
    currentStudioName(authUser)
  );
};

export const canUndoBillingTransfer = (product: any, authUser: any): boolean => {
  if (!product || product.archived === true || product.isArchived === true) {
    return false;
  }
  const status = String(product.status || "").trim().toUpperCase();
  if (status !== "COMPLETED") {
    return false;
  }
  if (String(product.commerceState || "").trim().toUpperCase() !== "SOLD") {
    return false;
  }
  const studio = currentStudioName(authUser);
  const creator = creatorStudioName(product);
  return Boolean(studio && creator && studio.toLowerCase() === creator.toLowerCase());
};
